import { NetworkService } from '../../../../services/networkService';

export const toggleSmartCreditsUtilisation = async (userId) => {
  const response = await NetworkService.patch(`/api/users/${userId}/toggle_auto_utilization`);
  return response;
};
